import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PrintFinish } from '../prop-types';
import ButtonRibbon from '../../_utils/button-ribbon';

export default function PrintFinishTabs({ finishes, selectedFinish }) {
  if (!finishes.length) {
    return null;
  }

  return (
    <ButtonRibbon
      className="prints_builder-finish-tabs"
      role="tablist"
      gradient>
      <ul className="nav nav-tabs w-100 d-flex flex-nowrap mt-2 px-lg-3 px-sm-1">
        {finishes.map(({ title, name }) => {
          const active = name === selectedFinish.name;
          const href = `${window.location.pathname}?finish=${title}`;

          return (
            <li
              className={classNames(
                'nav-item d-flex justify-content-center align-items-center text-nowrap mx-1',
                {
                  active: active,
                  'grey-zone': active,
                }
              )}
              onClick={() => (window.location.href = href)}
              key={name}>
              {title}
            </li>
          );
        })}
      </ul>
    </ButtonRibbon>
  );
}

PrintFinishTabs.propTypes = {
  finishes: PropTypes.arrayOf(PrintFinish).isRequired,
  selectedFinish: PrintFinish.isRequired,
};
